import { AxiosError } from "axios";
import { useState } from "react";
import { useDispatch } from "react-redux";

import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import axioInstance from "@/libs/axios";
import { setApiError } from "@/store/slices/errors/api-error.slice";
import { QuoteData } from "@/types/quote/quote-data";
import { apiErrorMappings } from "@/utils/errors/api-error-map";
import { trimFormValueOptional } from "@/utils/form-input.utils";
import { normalizePostageOption } from "@/utils/review.utils";

export const useSubmitReview = (
  {
    version,
    type,
    attributes,
    referenceId,
    viewPage,
    passportId,
  }: {
    version: string | undefined;
    type: string;
    attributes: QuoteData["attributes"];
    referenceId: string | undefined;
    viewPage: string;
    passportId?: string;
  },
  setButtonDisabled: (boolean: boolean) => void
) => {
  const [newQuote, setNewQuote] = useState<QuoteData>();
  const dispatch = useDispatch();

  const { current } = useWizard();

  const submitReview: () => Promise<void> = async () => {
    if (version) {
      try {
        const requestBody = {
          type,
          channel: "ONLINE",
          version,
          viewPage,
          attributes: {
            domain: attributes.domain,
            paymentDetails: {
              agreeTermsAndConditions:
                attributes?.paymentDetails?.agreeTermsAndConditions,
              agreeKeyFactAndTOB:
                attributes?.paymentDetails?.agreeKeyFactAndTOB,
              optOutAutoRenewal:
                current.uiElementControls?.hideAutoRenewalConsent === true
                  ? true
                  : attributes?.paymentDetails?.optOutAutoRenewal,
              postageOption: normalizePostageOption(
                attributes?.paymentDetails?.postageOption
              ),
              passportId: trimFormValueOptional(passportId),
            },
          },
        };

        const config = {
          data: requestBody,
        };
        const response = await axioInstance.patch(
          `/quote/${referenceId}/quoteReviewSubmit`,
          config
        );
        setNewQuote(response.data.data);
      } catch (error) {
        const axiosError = error as AxiosError;

        if (axiosError.response?.status === 401) {
          window.parent.location.href = "/";
        } else {
          dispatch(setApiError(await apiErrorMappings(axiosError)));
        }
      } finally {
        setButtonDisabled(false);
      }
    } else {
      setButtonDisabled(false);
    }
  };

  return [newQuote, submitReview];
};
